import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router";
import { AdminFab } from "@/components/admin/admin-fab";

/** Route IDs of the top-level admin list pages where the FAB should appear. */
const FAB_ROUTE_IDS = new Set([
  "/dashboard/_admin/user-management",
  "/dashboard/_admin/company/",
  "/dashboard/_admin/sites",
]);

export const Route = createFileRoute("/dashboard/_admin")({
  component: AdminLayout,
});

function AdminLayout() {
  const matches = useMatches();
  const leafRouteId = matches[matches.length - 1]?.routeId;
  const showFab = FAB_ROUTE_IDS.has(leafRouteId);

  return (
    <>
      <Outlet />
      {showFab && <AdminFab />}
    </>
  );
}
